import { useTheme } from '@emotion/react'
import CircularProgress from '@mui/material/CircularProgress'
import { ThemeProvider } from '@mui/material/styles'
import PropTypes from 'prop-types'

import muiTheme from '../../../../themes/muiTheme'

/**
 * Single-color brand spinner shown while a statement is processed.
 *
 * The app's own circular ProgressBar is a multicolor indicator, which does not match this
 * design, so this uses MUI under its own theme like the other MUI components here.
 */
const UploadSpinner = ({ size = 59, label = 'Processing document' }) => {
  const theme = useTheme()

  return (
    <ThemeProvider theme={muiTheme}>
      <CircularProgress
        size={size}
        thickness={4}
        aria-label={label}
        sx={{ color: theme.primaryColor ?? '#038ab7' }}
      />
    </ThemeProvider>
  )
}

UploadSpinner.propTypes = {
  size: PropTypes.number,
  label: PropTypes.string,
}

export default UploadSpinner
